let config = {};

if ('production' === process.env.REACT_APP_ENVIRONMENT) {
  let envConfig = {
    prices: {
      master: {
        discountPrice: 'price_1LVvNMBftTR3BbpMQroqVzNt',
        defaultPrice: 'price_1LVvNMBftTR3BbpM3H2Wivpo',
      },
      test: {
        discountPrice: 'price_1LVvNMBftTR3BbpMQroqVzNt',
        defaultPrice: 'price_1LVvNMBftTR3BbpM3H2Wivpo',
      },
      upSell: {
        easyHealthyMenu: 'price_1LIubbIlKxdbfNF5cAovex9x',
        walkingChallenge: 'price_1LIucRIlKxdbfNF5IS8eM7pV',
        veggieSnackGuide: 'price_1LIud1IlKxdbfNF5cybiLcx7',
        flatBellyRules: 'price_1LIuhKIlKxdbfNF5NmmtKnHF'
      },
      paidTrial: {
        master: [
          'price_1LVvNMBftTR3BbpMnmvjhvGr',
          'price_1LVvNMBftTR3BbpM01B9aB3c',
          'price_1LVvNMBftTR3BbpMapdlg1pE',
          'price_1LVvNMBftTR3BbpMRqNneeKm'
        ],
        test: [
          'price_1LVvNMBftTR3BbpMnmvjhvGr',
          'price_1LVvNMBftTR3BbpM01B9aB3c',
          'price_1LVvNMBftTR3BbpMapdlg1pE',
          'price_1LVvNMBftTR3BbpMRqNneeKm'
        ],
      }
    },
  };
  config = { ...envConfig };
}

if ('development' === process.env.REACT_APP_ENVIRONMENT) {
  let envConfig = {
    prices: {
      master: {
        discountPrice: 'price_1LNcZqIr0VH9QFtQMbUFevUa',
        defaultPrice: 'price_1LNcaBIr0VH9QFtQJHeDZTGz',
      },
      test: {
        discountPrice: 'price_1LNcLvIr0VH9QFtQhvUmngYp',
        defaultPrice: 'price_1LNcLvIr0VH9QFtQTgPs2Ccf',
      },
      upSell: {
        easyHealthyMenu: 'price_1LQrvXIr0VH9QFtQctXDvvAF',
        walkingChallenge: 'price_1LQrueIr0VH9QFtQlXWtl1vp',
        veggieSnackGuide: 'price_1LQrssIr0VH9QFtQXYqhARR9',
        flatBellyRules: 'price_1LIukJIr0VH9QFtQjU1mi92l'
      },
      paidTrial: {
        master: [
          'price_1KyEVqIr0VH9QFtQ6aqsGPdK',
          'price_1KyEVqIr0VH9QFtQHGiTpeWY',
          'price_1KyEVqIr0VH9QFtQlW1zM5O8',
          'price_1KyEVqIr0VH9QFtQBLGbThyr',
        ],
        test: [
          'price_1KyEVqIr0VH9QFtQ6aqsGPdK',
          'price_1KyEVqIr0VH9QFtQHGiTpeWY',
          'price_1KyEVqIr0VH9QFtQlW1zM5O8',
          'price_1KyEVqIr0VH9QFtQBLGbThyr',
        ]
      }
    },
  };
  config = { ...envConfig };
}

config.gaid = 'UA-208289779-1';

export default config;
